import AsyncStorage from '@react-native-async-storage/async-storage';

export async function getOrCreateDeviceId(): Promise<string> {
    try {
        let id = await AsyncStorage.getItem('device_id');
        if (!id) {
            // Generate a new random ID like: APP-DEVICE-A1B2C3D
            id = 'APP-DEVICE-' + Math.random().toString(36).substring(2, 9).toUpperCase();
            await AsyncStorage.setItem('device_id', id);
        }
        return id;
    } catch (e) {
        console.error('[DeviceId] Failed to read/write device ID, falling back to temp ID', e);
        return 'TEMP-DEVICE-' + Date.now();
    }
}
